<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <div
      v-if="terms.privacyPolicy"
      class="cf-content cf-content--header-center cf-content--center"
      v-html="terms.privacyPolicy"
    />

    <template v-else>
      <span class="cf-icon cf-icon--red cf-icon--large far fa-exclamation-circle" />

      <h4 class="cf-title cf-title--4">
        Oops! Our privacy policy failed to load. Please try again later.
      </h4>
    </template>

    <button
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      @click="$closeModal('privacyPolicy')"
    >
      Okay
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'PrivacyPolicy',

    computed: {
      ...mapGetters('content', ['terms'])
    }
  };
</script>
